import TagIds from '~/constants/common/tagIds';
import useGetVehicles from '~/hooks/home/useGetVehicles';
import AppliedFilters from '~/services/common/contracts/AppliedFilters';

const priceDropFilter: Partial<AppliedFilters> = {
  tagIds: [String(TagIds.PriceDrop)]
};

export default function useGetPriceDropVehicles() {
  return useGetVehicles(priceDropFilter, true, 'Price Drop Vehicles');
}
